import { Pipe, PipeTransform } from '@angular/core';
import { Aggregator } from '@liberty-financial/agp-shared';

import { aggregator } from '@env/aggregator/aggregator';

// Define a type for the new display mode
export type LoanTermDisplayMode = 'auto' | 'monthsOnly';

@Pipe({
  name: 'formatLoanTerm'
})
export class FormatLoanTermPipe implements PipeTransform {
  transform(term: number, short: boolean, displayMode: LoanTermDisplayMode = 'auto'): string {
    return FormatLoanTermPipe.format(term, short, displayMode);
  }

  static format(term: number, short: boolean, displayMode: LoanTermDisplayMode = 'auto'): string {
    // If displayMode is 'monthsOnly', show months if < 1 year, otherwise show years + months
    if (displayMode === 'monthsOnly') {
      let monthString = short ? 'mth' : 'month';
      let yearString = short ? 'yr' : 'year';
      let joinString = short ? ' ' : ' and ';
      
      let years = Math.floor(term / 12);
      let months = term % 12;
      
      // If less than 1 year, show only months
      if (years === 0) {
        return `${term} ${term === 1 ? monthString : monthString + 's'}`;
      }
      
      // If 1 year or more, show years and months
      let yearLabel = `${years} ${years === 1 ? yearString : yearString + 's'}`;
      if (months === 0) {
        return yearLabel;
      } else {
        let monthLabel = `${months} ${months === 1 ? monthString : monthString + 's'}`;
        return `${yearLabel}${joinString}${monthLabel}`;
      }
    }

    // Existing logic for 'auto' mode
    if (aggregator.name === Aggregator.MPM) {
      let monthString = short ? 'mth' : 'month';
      let yearString = short ? 'yr' : 'year';
      let joinString = short ? ' ' : ' and ';

      let years = Math.floor(term / 12);
      let termLabel =
        years + (years == 1 ? ` ${yearString}` : ` ${yearString}s`);
      let months = term % 12;
      return months == 0
        ? termLabel
        : termLabel +
            joinString +
            months +
            (months == 1 ? ` ${monthString}` : ` ${monthString}s`);
    } else {
      let yearString = short ? 'yr' : 'year';

      let years = Math.floor(term / 12);
      let yearLabel =
        years + (years == 1 ? ` ${yearString}` : ` ${yearString}s`);

      return yearLabel;
    }
  }
}
